export default __webpack_public_path__ + "static/media/VJA-1.7d931158.webp";